import PromotionProduct from "./components/promotion-product/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "promotion-products",
    data() {
        return {
            payload: {
                skip: 1,
            },
            skip: 8,
            currentLength: 0,
        };
    },
    components: {
        PromotionProduct,
    },
    computed: {
        ...mapGetters({
            getList: `promotions/getList`,
            getCurrentList: "promotions/getCurrentList",
            productLoading: "promotions/productLoading",
            getProductsLength: "promotions/getProductsLength",
        }),
        getProducts() {
            let arr = [];
            for (let i in this.getList) {
                if (this.getList[i].slug === this.$route.params.promo) {
                    for (let j in this.getList[i].products.data) {
                        arr.push(this.getList[i].products.data[j]);
                    }
                }
            }
            this.currentLength = arr.length;
            return arr.slice(-this.skip).reverse();
        },
        getTime() {
            for (let i in this.getList) {
                if (this.$route.params.promo === this.getList[i].slug) {
                    return this.getList[i];
                }
            }
        },
    },
    methods: {
        ...mapActions({
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            fetchNewPromoList: `promotions/GET_PROMOTIONS_CURRENT_LIST`,
        }),
        ...mapMutations({
            resetSkip: `promotions/RESET_SKIP`,
            resetLimit: `promotions/RESET_LIMIT`,
        }),
        getMoreProducts() {
            this.skip += this.skip;
        },
    },
    watch: {
        $route() {
            this.resetLimit();
            this.resetSkip();
            // this.resetLimit()
            this.fetchPromoList();
        },
    },
    created() {
        this.resetLimit();
        this.resetSkip();
        // this.resetLimit()
        this.fetchPromoList();

        // this.fetchPromoList(this.$route.params.slug)

        // this.fetchPromoList()
        // this.fetchNewPromoList()
        // this.getDateActions()
    },
    mounted() {},
};
